import * as React from 'react';
import { SVGProps } from 'react';

const SendMailSuccessIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_57_22761)">
      <path
        d="M96.8259 68.5654C94.7836 70.6026 92.0151 71.7445 89.1303 71.7392H10.8695C7.98463 71.7443 5.21615 70.6026 3.17383 68.5654L38.6521 33.0872L44.6521 37.4349C47.8306 39.7831 52.1692 39.7831 55.3477 37.4349L61.3477 33.0872L96.8259 68.5654Z"
        fill="#FFA000"
      />
      <path
        d="M97.9141 6.65305L61.3489 33.0879L55.3489 37.4356C52.1704 39.7838 47.8318 39.7838 44.6533 37.4356L38.6533 33.0879L2.04456 6.69666C4.08076 3.84911 7.36996 2.16385 10.8707 2.17486H89.1315C92.6066 2.17792 95.8707 3.84218 97.9141 6.65305Z"
        fill="#FFD54F"
      />
      <path
        d="M2.04364 6.69556L38.6524 33.0868L3.17414 68.565C1.13691 66.5227 -0.00500018 63.7542 9.49293e-05 60.8694V13.0432C-0.00948387 10.7641 0.706073 8.541 2.04364 6.69556Z"
        fill="#FFC107"
      />
      <path
        d="M100.001 13.0441V60.8703C100.006 63.7551 98.864 66.5236 96.8268 68.5659L61.3485 33.0877L97.9136 6.65283C99.2712 8.50725 100.002 10.746 100.001 13.0441Z"
        fill="#FFC107"
      />
      <path
        d="M50.0013 97.8259C63.2081 97.8259 73.9143 87.1197 73.9143 73.913C73.9143 60.7062 63.2081 50 50.0013 50C36.7946 50 26.0884 60.7062 26.0884 73.913C26.0884 87.1197 36.7946 97.8259 50.0013 97.8259Z"
        fill="#0479B7"
      />
      <path
        d="M45.6515 84.7829C45.0745 84.7839 44.5208 84.5557 44.1124 84.1481L35.4167 75.4523C34.5825 74.5888 34.6065 73.2125 35.4701 72.3784C36.3126 71.5646 37.6481 71.5646 38.4906 72.3784L45.6515 79.5352L59.3298 65.8568C60.1933 65.0227 61.5696 65.0467 62.4038 65.9102C63.2176 66.7528 63.2176 68.0883 62.4038 68.9308L47.1864 84.1483C46.7789 84.5546 46.227 84.7829 45.6515 84.7829Z"
        fill="#FAFAFA"
      />
    </g>
    <defs>
      <clipPath id="clip0_57_22761">
        <rect width="100" height="100" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default SendMailSuccessIcon;
